// Code copied form dropdown component
//Component use:
//<ep-selector [values]="dropdownValues" [(value)]="value"></selector>
//<ep-selector codeSet="LineCode" [values] = "{Code:'ALL',Code_Desc: "All Lines"} [(value)] = "value" > </selector>
//<ep-selector codeSet="LineCode" [(value)] = "model.Line_Code"  (valueChange) = "valueChangeLineCode($event)" > </selector>


//TODO  Change DropdownValue type to CodeValue  (more generic)

//TODO   Implement in a more efficient way.   Rather than relying up bootstrap "hidden" classes  
// calculate min button with based on parent width and use ngIf.

// Return simple value (CODE) or complex value (CODE,DESC)?   Later may be better if description is needed outside of control.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CodeSetDataService } from '@Core/services/proprietary/codeset-data.service';
import { DropdownValue } from './dropdown.component';

@Component({
    standalone: false,
    selector: 'ep-selector',
    template: `
    <div class="unity-form-group select">
      <label for="{{ name }}" *ngIf="label">{{ label }}</label>
      <div [class]="'unity-form-row ' + dropdownClass">
        <select [disabled]="controlDisabled" [(ngModel)]="value" (ngModelChange)="onChange($event)">
          <option *ngIf="nullValue" [value]="nullValue.Code" [ngbTooltip]="nullValue.Tooltip || nullValue.Code_Desc">
            &lt;{{ nullValue.Code_Desc }}&gt;
          </option>
          <option *ngFor="let v of values" [value]="v.Code" [ngbTooltip]="v.Tooltip">{{ v.Code_Desc }}</option>
        </select>
        <aurora-icon icon="chevron-down"></aurora-icon>
      </div>
      <aurora-segmented-button
        [class]="buttonGroupClass"
        type="text"
        [options]="segmentOptions"
        [value]="value"
        (change)="onSegmentChange($any($event).detail.value)"
        [style.pointer-events]="controlDisabled ? 'none' : null"
        [style.opacity]="controlDisabled ? 0.5 : null"
      ></aurora-segmented-button>
    </div>
  `,
    providers: []
})
export class SelectorComponent {
    private _values: DropdownValue[] = [];
    private _nullValue: DropdownValue = null;

    /** Rebuilt on input change so aurora-segmented-button isn't handed a new array every CD pass. */
    segmentOptions: { label: string; value: string }[] = [];

    @Input()
    set values(value: DropdownValue[]) {
        this._values = value ?? [];
        this.setSegmentOptions();
    }

    get values(): DropdownValue[] {
        return this._values;
    }

    @Input()
    set nullValue(value: DropdownValue) {
        this._nullValue = value;
        this.setSegmentOptions();
    }

    get nullValue(): DropdownValue {
        return this._nullValue;
    }

    @Input()
    value: string = null;

    @Input()
    codeSet: string = 'NONE';

    @Input('disabled')
    controlDisabled: boolean = false; //is this the right way?

    @Input()
    set label(value: string) {
        this._label = value;
        // CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
        // this.setRootID();
        // END CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    }

    @Input()
    set name(value: string) {
        this._name = value;
        // CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
        // this.setRootID();
        // END CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    }

    get label(): string {
        return this._label;
    }

    get name(): string {
        return this._name;
    }

    _minButtonModeSize: string;
    get minButtonModeSize(): string {
        return this._minButtonModeSize;
    }
    @Input()
    set minButtonModeSize(value: string) {
        this._minButtonModeSize = value;
        if (value) {
            switch (value.toLowerCase()) {
                case 'xs':
                    this.buttonGroupClass = 'd-block';
                    this.dropdownClass = 'd-none';
                    break;
                case 'sm':
                    this.buttonGroupClass = 'd-none d-sm-block';
                    this.dropdownClass = 'd-block d-sm-none';
                    break;
                case 'md':
                    this.buttonGroupClass = 'd-none d-md-block';
                    this.dropdownClass = 'd-sm-block d-md-none';
                    break;
                case 'lg':
                    this.buttonGroupClass = 'd-none d-lg-block';
                    this.dropdownClass = 'd-md-block d-lg-none';
                    break;
                case 'xl':
                    this.buttonGroupClass = 'd-none d-xl-block';
                    this.dropdownClass = 'd-lg-block d-xl-none';
                    break;
                case 'nb' /* no buttons */:
                    this.buttonGroupClass = 'd-none';
                    this.dropdownClass = 'd-block';
                    break;
            }
        }
    }

    @Output()
    // is this the proper name? should in match the event on the control????   select, change, onchanged, valuechanged?????
    valueChange: EventEmitter<any>;
    private _name: string = null;
    private _label: string = null;
    // CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    // private _rootID: string = 'Unknown';
    // END CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    errorMessage: string;

    dropdownClass: string = 'd-none d-sm-none d-md-none d-lg-none d-xl-none';
    buttonGroupClass: string = '';

    constructor(private codeSetDataService: CodeSetDataService) {
        this.valueChange = new EventEmitter();
    }

    ngOnInit() {
        if (this.codeSet.toUpperCase() != 'NONE') {
            this.getCodes(this.codeSet);
        }
        this.getUnityDropdownClass();
    }

    //   CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    // Â Â REMOVEDÂ IDÂ SETTINGÂ CODEÂ ADDEDÂ FORÂ ASCENTIALÂ TEST
    // Â Â LATERÂ ONÂ WEÂ SHOULDÂ CONSIDERÂ AÂ STORYÂ TOÂ REMOVEÂ COMMENTEDÂ OUTÂ CODEÂ IFÂ WEÂ DON'TÂ HAVEÂ NEEDÂ FORÂ THEÂ IDÂ SETTING.
    //
    //   setRootID() {
    //     if (this._name) {
    //       this._rootID = this._name.replace(/[^\w]|_/g, ''); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else if (this._label) {
    //       this._rootID = this._label.replace(/[^\w]|_/g, ''); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else {
    //       this._rootID = 'Unknown';
    //     }
    //   }
    //
    //   buildOptionIDAttribute(option: any) {
    //     if (option != null) {
    //       return (
    //         'Option' +
    //         this._rootID +
    //         option
    //           .toString()
    //           .replace(/[^\w]|_/g, '')
    //           .toUpperCase()
    //       ); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else {
    //       return 'Option' + this._rootID + 'Null';
    //     }
    //   }
    //
    //
    //   buildSelectorIDAttribute() {
    //     return 'Select' + this._rootID;
    //   }
    //
    //   END CLEAN-UP!Â 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe

    getCodes(codeSet: string) {
        this.codeSetDataService.get(codeSet).subscribe(
            (values) => {
                this.values = values;
            },
            (error) => (this.errorMessage = <any>error)
        );
    }

    get diagnostic() {
        return JSON.stringify(this.values);
    }

    //use "on" prefix on events?
    onChange(value: any) {
        //console.log("emitting valueChange(" + value + ")");
        if (value == 'null') {
            value = null;
            this.value = null;
        }
        this.valueChange.emit(value);
    }

    setSegmentOptions() {
        const options = this._values.map(v => ({ label: v.Code_Desc, value: v.Code }));
        if (this._nullValue) {
            options.unshift({ label: this._nullValue.Code_Desc, value: this._nullValue.Code });
        }
        this.segmentOptions = options;
    }

    onSegmentChange(value: string) {
        this.value = value;
        this.onChange(this._nullValue && value === this._nullValue.Code ? null : value);
    }

    clear() {
        this.value = '';
        this.valueChange.emit('');
    }

    getUnityDropdownClass() {
        if (this._minButtonModeSize) {
            switch (this._minButtonModeSize.toLowerCase()) {
                case 'xs':
                    this.dropdownClass = 'd-none';
                    break;
                case 'sm':
                    this.dropdownClass = 'd-flex d-sm-none';
                    break;
                case 'md':
                    this.dropdownClass = 'd-sm-flex d-md-none';
                    break;
                case 'lg':
                    this.dropdownClass = 'd-md-flex d-lg-none';
                    break;
                case 'xl':
                    this.dropdownClass = 'd-lg-flex d-xl-none';
                    break;
                case 'nb' /* no buttons */:
                    this.dropdownClass = 'd-flex';
                    break;
            }
        } else {
            return '';
        }
    }
}
